import "./DCAsset.css";
import FileViewer from 'react-file-viewer';

type DCAssetProps = {
    title: string;
    url: string;
    onCancel: () => void;
    onSubmit: () => void;
}

export const DCAsset = ({
    title,
    url,
    onCancel,
    onSubmit
    } : DCAssetProps) => {

    const fileExtension = url.split('.').pop();
    const viewableExtension = fileExtension === "docx" || fileExtension === "pdf";

    return (
        <div className="dc-asset">
            {viewableExtension && 
                <FileViewer
                    fileType={fileExtension}
                    filePath={url}  // Passing the URL to the file
                />
            }
            {!viewableExtension &&
                <iframe src={url} />
            }
            
        </div>
    )
}